module.exports = __webpack_public_path__ + "img/image32.8cc36a14.png";